// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid___LISdg","title":"title___27LfN"};